export default {
    captureVisit() {
        if (typeof window.OMM !== undefined && window.OMM.AssignedContentItem !== null) {
            let raw = window.localStorage.getItem("recently-visited") ?? "[]";
            let recentlyVisited = JSON.parse(raw);
            let unique = recentlyVisited.filter((page) => {
                return page.url !== window.location.pathname + window.location.search;
            });

            unique.push({
                id: window.OMM.AssignedContentItem,
                url: window.location.pathname + window.location.search,
                sort: Date.now(),
            });

            let sorted = unique.reverse();
            window.localStorage.setItem("recently-visited", JSON.stringify(sorted));
        }
    },
    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
}


